import type { Messages } from '@ah/i18n';

/** Greek — primary/default locale (ADR-015). Source of truth: a missing `en` key falls back here. */
export const el: Messages = {
  auth: {
    login: {
      title: 'Σύνδεση διαχειριστή',
      email: 'Email',
      password: 'Κωδικός',
      submit: 'Σύνδεση',
      submitting: 'Σύνδεση…',
      missingFields: 'Παρακαλούμε συμπλήρωσε email και κωδικό.',
      wrongPortal: 'Αυτός ο πίνακας ελέγχου είναι μόνο για διαχειριστές.',
      failed: 'Η σύνδεση απέτυχε. Δοκίμασε ξανά.',
      provisionNotice: 'Οι λογαριασμοί διαχειριστών δημιουργούνται από επόπτη (',
      provisionNoticeSuffix: ') — δεν υπάρχει αυτόματη εγγραφή για αυτόν τον πίνακα ελέγχου.',
      twoFactorTitle: 'Επιβεβαίωση δύο βημάτων',
      twoFactorIntro: 'Εισήγαγε τον 6ψήφιο κωδικό από την εφαρμογή επαλήθευσης, ή έναν από τους κωδικούς ανάκτησης.',
      code: 'Κωδικός',
      verify: 'Επιβεβαίωση',
      verifying: 'Επιβεβαίωση…',
      verifyFailed: 'Η επιβεβαίωση απέτυχε. Δοκίμασε ξανά.',
      backToLogin: '← Πίσω στη σύνδεση',
    },
  },
  nav: {
    dashboard: 'Πίνακας ελέγχου',
    backDashboard: '← Πίνακας ελέγχου',
    therapists: 'Θεραπευτές',
    users: 'Χρήστες',
    reviews: 'Κριτικές',
    content: 'Περιεχόμενο',
    specializations: 'Ειδικότητες',
    media: 'Πολυμέσα',
    payments: 'Πληρωμές',
    reports: 'Αναφορές',
    settings: 'Ρυθμίσεις',
    security: 'Ασφάλεια',
    signOut: 'Αποσύνδεση',
    language: 'Γλώσσα',
  },
  common: {
    loading: 'Φόρτωση…',
    working: 'Επεξεργασία…',
    save: 'Αποθήκευση',
    saving: 'Αποθήκευση…',
    cancel: 'Ακύρωση',
    close: 'Κλείσιμο',
    edit: 'Επεξεργασία',
    delete: 'Διαγραφή',
    actionFailed: 'Η ενέργεια απέτυχε. Δοκίμασε ξανά.',
  },
  dashboard: {
    title: 'Πίνακας ελέγχου',
    loadError: 'Δεν ήταν δυνατή η φόρτωση της επισκόπησης.',
    totalUsers: 'Σύνολο χρηστών',
    newLast7Days: '+{{count}} τις τελευταίες 7 ημέρες',
    clients: 'Πελάτες',
    therapists: 'Θεραπευτές',
    totalBookings: 'Σύνολο κρατήσεων',
    anonymousVsNamed: 'Ανώνυμες έναντι επώνυμων',
    namedSuffix: '{{count}} επώνυμες',
    calls: 'Κλήσεις',
    avgCallDuration: 'Μέση διάρκεια κλήσης',
    minutesSuffix: '{{minutes}} λεπτά',
    messagesSent: 'Μηνύματα που στάλθηκαν',
    completedRevenue: 'Ολοκληρωμένα έσοδα',
    platformFeeSuffix: '{{amount}} προμήθεια πλατφόρμας',
    recentBookings: 'Πρόσφατες κρατήσεις',
    scheduled: 'Προγραμματισμένη',
    status: 'Κατάσταση',
    mode: 'Τρόπος',
    noBookings: 'Δεν υπάρχουν κρατήσεις ακόμα.',
    generatedAt: 'Δημιουργήθηκε {{when}}',
  },
  therapists: {
    title: 'Θεραπευτές',
    tabPending: 'Υπό έλεγχο',
    tabApproved: 'Εγκεκριμένοι',
    tabSuspended: 'Ανασταλμένοι',
    tabRejected: 'Απορριφθέντες',
    tabAll: 'Όλοι',
    loadError: 'Δεν ήταν δυνατή η φόρτωση των θεραπευτών.',
    actionFailed: 'Η ενέργεια απέτυχε. Δοκίμασε ξανά.',
    photoUploadFailed: 'Το ανέβασμα φωτογραφίας απέτυχε.',
    saveFailed: 'Η αποθήκευση του προφίλ απέτυχε.',
    colName: 'Όνομα',
    colEmail: 'Email',
    colLicense: 'Άδεια',
    colSpecialties: 'Ειδικότητες',
    colStatus: 'Κατάσταση',
    colActions: 'Ενέργειες',
    approve: 'Έγκριση',
    reject: 'Απόρριψη',
    suspend: 'Αναστολή',
    editProfile: 'Επεξεργασία προφίλ',
    closeEdit: 'Κλείσιμο',
    noTherapists: 'Δεν υπάρχουν θεραπευτές σε αυτή την κατηγορία.',
    photoLabel: 'Φωτογραφία (εμφανίζεται στην αρχική σελίδα)',
    noPhotoYet: 'Δεν υπάρχει φωτογραφία ακόμα',
    tabEl: 'Ελληνικά',
    tabEn: 'English',
    requiredBadge: 'υποχρεωτικό',
    optionalBadge: 'προαιρετικό',
    completeBadge: '✓ πλήρες',
    incompleteBadge: 'ελλιπές',
    headlineLabel: 'Τίτλος (π.χ. «Κλινική Ψυχολόγος, 12 χρόνια εμπειρίας»)',
    bioLabel: 'Βιογραφικό (σύντομο, φαίνεται στην κάρτα)',
    introVideoLabel: 'Βίντεο παρουσίασης (URL — προαιρετικό, κοινό και για τις δύο γλώσσες)',
    caseTagsLabel: 'Περιστατικά (tags, χωρισμένα με κόμμα — διαφορετικά από τις ειδικότητες)',
    caseTagsPlaceholderEl: 'κρίσεις πανικού, πένθος, burnout',
    caseTagsPlaceholderEn: 'panic attacks, grief, burnout',
    spokenLanguagesLegend: 'Γλώσσες συνεδρίας',
    saveProfile: 'Αποθήκευση προφίλ',
  },
  content: {
    title: 'Περιεχόμενο',
    landingTitle: 'Αρχική σελίδα (landing)',
    landingHint: 'Ό,τι αλλάζεις εδώ εμφανίζεται στην αρχική σελίδα (http://localhost:5173) μόλις πατήσεις Publish.',
    legalTitle: 'Νομικά κείμενα',
    legalHint: 'Όροι Χρήσης (/terms) και Πολιτική Απορρήτου (/privacy) — εμφανίζονται στο footer και στη σελίδα εγγραφής. Ενημέρωσέ τα όποτε χρειάζεται, χωρίς redeploy.',
    loadError: 'Δεν ήταν δυνατή η φόρτωση του περιεχομένου.',
    emptyBody: '«{{key}}»: το κείμενο δεν μπορεί να είναι κενό.',
    draftSaved: 'Αποθηκεύτηκε πρόχειρο για «{{key}}». Πάτησε Publish για να εμφανιστεί.',
    saveFailed: 'Η αποθήκευση απέτυχε.',
    published: 'Δημοσιεύτηκε το «{{key}}».',
    publishFailed: 'Η δημοσίευση απέτυχε.',
    imageUploaded: 'Ανέβηκε η εικόνα — πάτησε Save & Publish στο «{{key}}» για να εμφανιστεί.',
    uploadFailed: 'Το ανέβασμα απέτυχε.',
    stateDefault: 'default κείμενο (δεν έχει επεξεργαστεί)',
    stateDraftNoTranslation: 'πρόχειρο χωρίς el μετάφραση',
    stateUnpublished: 'πρόχειρο — ΔΕΝ έχει δημοσιευτεί',
    statePublished: 'δημοσιευμένο ✓',
    statePublishedNewerDraft: 'δημοσιευμένο, με νεότερο πρόχειρο',
    saveDraft: 'Αποθήκευση πρόχειρου',
    saveAndPublish: 'Αποθήκευση & Δημοσίευση',
  },
  specializations: {
    title: 'Ειδικότητες',
    slugPlaceholder: 'slug (π.χ. anxiety)',
    nameEnPlaceholder: 'Όνομα (en)',
    nameElPlaceholder: 'Όνομα (el, προαιρετικό)',
    add: 'Προσθήκη',
    loadError: 'Δεν ήταν δυνατή η φόρτωση των ειδικοτήτων.',
    actionFailed: 'Η ενέργεια απέτυχε. Δοκίμασε ξανά.',
    createFailed: 'Δεν ήταν δυνατή η δημιουργία της ειδικότητας.',
    colSlug: 'Slug',
    colName: 'Όνομα',
    colStatus: 'Κατάσταση',
    colActions: 'Ενέργειες',
    active: 'Ενεργή',
    inactive: 'Ανενεργή',
    activate: 'Ενεργοποίηση',
    deactivate: 'Απενεργοποίηση',
    noItems: 'Δεν υπάρχουν ειδικότητες ακόμα.',
  },
  media: {
    title: 'Πολυμέσα',
    uploading: 'Ανέβασμα…',
    loadError: 'Δεν ήταν δυνατή η φόρτωση των πολυμέσων.',
    uploadFailed: 'Το ανέβασμα απέτυχε.',
    deleteFailed: 'Η διαγραφή απέτυχε.',
    noItems: 'Δεν έχουν ανέβει πολυμέσα ακόμα.',
  },
  users: {
    title: 'Χρήστες',
    tabAll: 'Όλοι',
    tabClients: 'Πελάτες',
    tabTherapists: 'Θεραπευτές',
    tabAdmins: 'Διαχειριστές',
    searchPlaceholder: 'Αναζήτηση email / ψευδώνυμο / όνομα',
    loadError: 'Δεν ήταν δυνατή η φόρτωση των χρηστών.',
    suspendReasonPrompt: 'Αιτιολογία αναστολής (προαιρετικό):',
    actionFailed: 'Η ενέργεια απέτυχε. Δοκίμασε ξανά.',
    colName: 'Ψευδώνυμο / Όνομα',
    colEmail: 'Email',
    colRole: 'Ρόλος',
    colStatus: 'Κατάσταση',
    colActions: 'Ενέργειες',
    deleted: 'Διαγράφηκε',
    suspended: 'Ανασταλμένος',
    suspendedWithReason: 'Ανασταλμένος ({{reason}})',
    active: 'Ενεργός',
    suspend: 'Αναστολή',
    reactivate: 'Επανενεργοποίηση',
    noUsers: 'Κανένας χρήστης δεν ταιριάζει με αυτό το φίλτρο.',
  },
  reviews: {
    title: 'Κριτικές',
    tabAll: 'Όλες',
    tabVisible: 'Ορατές',
    tabHidden: 'Κρυφές',
    loadError: 'Δεν ήταν δυνατή η φόρτωση των κριτικών.',
    hideReasonPrompt: 'Αιτιολογία απόκρυψης (προαιρετικό):',
    actionFailed: 'Η ενέργεια απέτυχε. Δοκίμασε ξανά.',
    colRating: 'Βαθμολογία',
    colComment: 'Σχόλιο',
    colStatus: 'Κατάσταση',
    colActions: 'Ενέργειες',
    hidden: 'Κρυφή',
    hiddenWithReason: 'Κρυφή ({{reason}})',
    visible: 'Ορατή',
    hide: 'Απόκρυψη',
    unhide: 'Εμφάνιση',
    noReviews: 'Δεν υπάρχουν κριτικές σε αυτή την κατηγορία.',
  },
  payments: {
    title: 'Πληρωμές',
    loadError: 'Δεν ήταν δυνατή η φόρτωση των πληρωμών.',
    retryFailed: 'Η επανάληψη απέτυχε.',
    exportFailed: 'Η εξαγωγή απέτυχε.',
    downloadFailed: 'Η λήψη απέτυχε.',
    weeklyPayouts: 'Εβδομαδιαίες πληρωμές',
    weeklyPayoutsHintPrefix: 'Οι παρτίδες δημιουργούνται από το script χειριστή',
    weeklyPayoutsHintSuffix: '(εξωτερικό cron, κάθε Παρασκευή). Μια αποτυχημένη πληρωμή παραμένει εδώ μέχρι να επαναληφθεί — δεν ξανασυγκεντρώνει ποτέ τις κρατήσεις.',
    colPeriod: 'Περίοδος',
    colNet: 'Καθαρό',
    colBookings: 'Κρατήσεις',
    colStatus: 'Κατάσταση',
    colActions: 'Ενέργειες',
    retrying: 'Επανάληψη…',
    retry: 'Επανάληψη',
    noPayouts: 'Δεν υπάρχουν πληρωμές ακόμα.',
    invoiceExport: 'Εξαγωγή τιμολογίων',
    invoiceExportHint: 'Δημιουργεί το μηνιαίο κατάστημα προμηθειών πλατφόρμας — ένα ZIP με PDF ανά κράτηση και μια σύνοψη Excel. Κανένα από τα δύο αρχεία δεν περιλαμβάνει ταυτότητα πελάτη ή θεραπευτή.',
    yearLabel: 'Έτος',
    monthLabel: 'Μήνας',
    generating: 'Δημιουργία…',
    generateExport: 'Δημιουργία εξαγωγής',
    colMonth: 'Μήνας',
    colInvoices: 'Τιμολόγια',
    colFiles: 'Αρχεία',
    downloading: 'Λήψη…',
    noExports: 'Δεν έχουν δημιουργηθεί εξαγωγές ακόμα.',
  },
  paymentsSettings: {
    title: 'Ρυθμίσεις πληρωμών',
    intro: 'Ρύθμισε το Stripe από εδώ αντί για το αρχείο',
    introMid: 'του server. Μια τιμή που αποθηκεύεται εδώ υπερισχύει της αντίστοιχης μεταβλητής',
    introSuffix: '— «Επαναφορά σε .env» καθαρίζει την υπερίσχυση. Τα μυστικά κλειδιά κρυπτογραφούνται και δεν εμφανίζονται ποτέ ξανά πλήρως — μόνο μια συγκεκαλυμμένη ένδειξη.',
    loadError: 'Δεν ήταν δυνατή η φόρτωση των ρυθμίσεων Stripe.',
    saveFailed: 'Η αποθήκευση απέτυχε.',
    revertFailed: 'Η επαναφορά απέτυχε.',
    fromDashboard: 'από τον πίνακα',
    fromEnv: 'από .env',
    notSet: 'μη ορισμένο',
    connectionStatus: 'Κατάσταση σύνδεσης',
    secretKey: 'Μυστικό κλειδί',
    notConfigured: 'Μη ρυθμισμένο',
    liveMode: 'ΚΑΝΟΝΙΚΗ λειτουργία',
    testMode: 'ΔΟΚΙΜΑΣΤΙΚΗ λειτουργία',
    platformWebhook: 'Webhook πλατφόρμας',
    connectWebhook: 'Webhook Connect',
    lastReceived: 'Τελευταία λήψη: {{when}}',
    never: 'ποτέ',
    lastChanged: 'Τελευταία αλλαγή {{when}} από χρήστη {{userId}}',
    secretsTitle: 'Μυστικά',
    stripeSecretKey: 'Μυστικό κλειδί Stripe',
    platformWebhookSecret: 'Μυστικό webhook πλατφόρμας',
    connectWebhookSecret: 'Μυστικό webhook Connect',
    revertToEnv: 'Επαναφορά σε .env',
    marketplaceTitle: 'Αγορά',
    platformFee: 'Προμήθεια πλατφόρμας (%)',
    currency: 'Νόμισμα',
    statementDescriptor: 'Περιγραφή κίνησης',
    statementDescriptorPlaceholder: 'Εμφανίζεται στην κίνηση κάρτας του πελάτη',
    connectUrlsTitle: 'URLs εγγραφής Connect',
    returnUrl: 'URL επιστροφής',
    refreshUrl: 'URL ανανέωσης',
    payoutScheduleTitle: 'Πρόγραμμα εβδομαδιαίων πληρωμών',
    payoutScheduleHint: 'Μόνο ενημερωτικό — δεν υπάρχει scheduler εντός εφαρμογής. Απλώς σου λέει πού να δείξεις το εξωτερικό cron σου',
    day: 'Ημέρα',
    hour: 'Ώρα (UTC)',
    saving: 'Αποθήκευση…',
    saveChanges: 'Αποθήκευση αλλαγών',
    weekdaySunday: 'Κυριακή',
    weekdayMonday: 'Δευτέρα',
    weekdayTuesday: 'Τρίτη',
    weekdayWednesday: 'Τετάρτη',
    weekdayThursday: 'Πέμπτη',
    weekdayFriday: 'Παρασκευή',
    weekdaySaturday: 'Σάββατο',
  },
  security: {
    title: 'Ασφάλεια',
    loadError: 'Δεν ήταν δυνατή η φόρτωση της κατάστασης 2FA.',
    startSetupFailed: 'Δεν ήταν δυνατή η έναρξη της ρύθμισης.',
    incorrectCode: 'Λανθασμένος κωδικός — δοκίμασε ξανά.',
    disableFailed: 'Δεν ήταν δυνατή η απενεργοποίηση του 2FA — έλεγξε τον κωδικό πρόσβασης και τον κωδικό επιβεβαίωσης.',
    twoFactorTitle: 'Επαλήθευση δύο βημάτων',
    enabled: 'Ενεργοποιημένο',
    enabledSince: ' — από {{when}}',
    enabledHint: 'Κάθε σύνδεση σε αυτόν τον πίνακα ζητά έναν κωδικό από την εφαρμογή επαλήθευσής σου μετά τον κωδικό πρόσβασης.',
    disable: 'Απενεργοποίηση επαλήθευσης δύο βημάτων',
    accountPassword: 'Κωδικός λογαριασμού',
    currentCodeLabel: 'Τρέχων κωδικός εφαρμογής ή κωδικός ανάκτησης',
    disabling: 'Απενεργοποίηση…',
    confirmDisable: 'Επιβεβαίωση απενεργοποίησης',
    cancel: 'Ακύρωση',
    notEnabled: 'Μη ενεργοποιημένο.',
    notEnabledHint: 'Προσθέτει ένα υποχρεωτικό δεύτερο βήμα στη σύνδεση διαχειριστή μέσω εφαρμογής επαλήθευσης (Google Authenticator, Authy, 1Password, ...). Συνιστάται ιδιαίτερα για κάθε λογαριασμό διαχειριστή.',
    starting: 'Έναρξη…',
    setUp: 'Ρύθμιση επαλήθευσης δύο βημάτων',
    step1Title: '1. Σάρωσε τον κωδικό QR',
    step1Hint: 'Άνοιξε την εφαρμογή επαλήθευσης και σάρωσε αυτόν τον κωδικό. Δεν μπορείς να σαρώσεις; Εισήγαγε το μυστικό παρακάτω με το χέρι.',
    qrAlt: 'Κωδικός QR επαλήθευσης δύο βημάτων',
    manualEntrySecret: 'Μυστικό χειροκίνητης εισαγωγής:',
    step2Title: '2. Εισήγαγε τον τρέχοντα κωδικό για επιβεβαίωση',
    confirming: 'Επιβεβαίωση…',
    confirmAndEnable: 'Επιβεβαίωση και ενεργοποίηση',
    enabledNowTitle: 'Η επαλήθευση δύο βημάτων είναι πλέον ενεργοποιημένη',
    saveRecoveryCodes: 'Αποθήκευσε τώρα αυτούς τους 10 κωδικούς ανάκτησης — εμφανίζονται μόνο αυτή τη φορά.',
    recoveryCodesHint: 'Αν χάσεις την πρόσβαση στην εφαρμογή επαλήθευσής σου, κάθε κωδικός σου επιτρέπει να συνδεθείς μία φορά. Αποθήκευσέ τους κάπου ασφαλές (διαχειριστής κωδικών, εκτυπωμένους και κλειδωμένους) — όχι σε email ή μήνυμα συνομιλίας.',
    savedAcknowledgement: 'Αποθήκευσα αυτούς τους κωδικούς ανάκτησης κάπου ασφαλές',
    done: 'Τέλος',
  },
  reports: {
    title: 'Οικονομικές αναφορές',
    intro: 'Μόνο εγκεκριμένες πληρωμές — κρατήσεις που είναι εξουσιοδοτημένες αλλά μη εγκεκριμένες, ακυρωμένες, αποτυχημένες ή επιστραμμένες δεν προσμετρώνται ποτέ ως έσοδα. Καμία ταυτότητα πελάτη δεν εμφανίζεται πουθενά σε αυτή τη σελίδα ή στις εξαγωγές της.',
    loadError: 'Δεν ήταν δυνατή η φόρτωση της αναφοράς.',
    sessionsLoadError: 'Δεν ήταν δυνατή η φόρτωση των συνεδριών.',
    exportFailed: 'Η εξαγωγή απέτυχε.',
    from: 'Από',
    to: 'Έως',
    groupBy: 'Ομαδοποίηση κατά',
    month: 'Μήνας',
    year: 'Έτος',
    totalTurnover: 'Συνολικός τζίρος ({{count}} συνεδρίες)',
    platformRevenue: 'Έσοδα πλατφόρμας',
    therapistEarnings: 'Έσοδα θεραπευτών',
    byPeriod: 'Ανά {{granularity}}',
    exporting: 'Εξαγωγή…',
    exportCsv: 'Εξαγωγή CSV',
    colPeriod: 'Περίοδος',
    colTurnover: 'Τζίρος',
    colPlatformFee: 'Προμήθεια πλατφόρμας',
    colTherapistEarnings: 'Έσοδα θεραπευτή',
    colSessions: 'Συνεδρίες',
    noPaymentsInPeriod: 'Δεν υπάρχουν εγκεκριμένες πληρωμές σε αυτή την περίοδο.',
    byTherapist: 'Ανά θεραπευτή',
    colTherapist: 'Θεραπευτής',
    colEarnings: 'Έσοδα',
    sessionsAction: 'Συνεδρίες',
    sessionsFor: 'Συνεδρίες — {{name}}',
    colBooking: 'Κράτηση',
    colCaptured: 'Εγκρίθηκε',
    colStatus: 'Κατάσταση',
    colGross: 'Μικτό',
    colNet: 'Καθαρό',
    noSessionsInPeriod: 'Δεν υπάρχουν εγκεκριμένες συνεδρίες σε αυτή την περίοδο.',
  },
};
